// Selected rows are loads (OrderItems); some bulk actions act per order (invoice)
// or per customer (send order list). These dedupe a load selection up to a grain.

export function orderIdOf(row: any): string | null {
  const value = row?.orderId ?? row?.order?.id;
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

export function customerIdOf(row: any): string | null {
  const value = row?.order?.customerId ?? row?.cust?.id ?? row?.order?.customer?.id;
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

export function customerNameOf(row: any): string | null {
  return row?.cust?.name ?? row?.order?.customer?.name ?? null;
}

function distinctBy(rows: any[], keyOf: (row: any) => string | null): string[] {
  return Array.from(new Set((rows || []).map(keyOf).filter((id): id is string => Boolean(id))));
}

export function distinctOrderIds(rows: any[]): string[] {
  return distinctBy(rows, orderIdOf);
}

// Distinct orders in the selection (id + a representative label), first row seen
// wins the label. Used by per-order actions like Invoice.
export function distinctOrders(rows: any[]): { id: string; label: string }[] {
  const seen = new Map<string, string>();
  for (const row of rows || []) {
    const id = orderIdOf(row);
    if (id && !seen.has(id)) seen.set(id, row?.loadNumber || `order ${id.slice(-6)}`);
  }
  return [...seen.entries()].map(([id, label]) => ({ id, label }));
}

export function distinctCustomerIds(rows: any[]): string[] {
  return distinctBy(rows, customerIdOf);
}

// Distinct customers in the selection (id + name), first name seen wins. Used by
// per-customer actions like Send order list.
export function distinctCustomers(rows: any[]): { id: string; name: string | null }[] {
  const seen = new Map<string, string | null>();
  for (const row of rows || []) {
    const id = customerIdOf(row);
    if (id && !seen.has(id)) seen.set(id, customerNameOf(row));
  }
  return [...seen.entries()].map(([id, name]) => ({ id, name }));
}
